export const GA_EVENTS = {
    RWC_SECTION_ENTERED: {
        event: "rwc_section_entered",
        eventCategory: "RWC_landing_page",
        eventAction: "section_name",
        eventLabel: "header"
    },
    CHR_LANDING_PAGE: {
        event: "custom_event",
        eventCategory: "CHR_Landing_page",
        eventAction: "CHR_landing_page",
        eventLabel: ""
    }
};
